import fanlistings from './object-lists/fanlistings';
import { useMemo } from 'react';

function Fanlistings(props) {
    const listFansites = useMemo(() => props.shuffle(fanlistings.map(temp =><a className = "fansite-item" target="_blank" rel="noopener noreferrer" key={temp.url} href={temp.url}><img src={temp.thumbnail}/></a> )), []);
    return (
      <div className='status-wrapper' id="fanlistings-wrapper">
              <div className='status-title'>
                <p id="webrings-title">⊹ fanlistings</p>
              </div>
              <div className="status-details" id="fanlistings-details">
                <div id='fansites'>
                  {listFansites}
                </div>
              </div>

      </div>
    );
  }

  export default Fanlistings;